import { LocalStorage } from "@/service/local-storage";
import { Api } from "@/util/api";

// 8 hours
const SUGGESTED_PRODUCTS_CACHE_EXPIRATION_DURATION = (8 * 60 * 60 * 1000);

export class SuggestedProducts {
	private static instance: SuggestedProducts;
	private suggestedProductKeys?: string[];

	private constructor(private localStorage: LocalStorage, private api: Api) {
		this.suggestedProductKeys = this.getSuggestedProductsFromLocalStorage();
	}

	static getInstance(): SuggestedProducts {
		if (SuggestedProducts.instance == null) {
			SuggestedProducts.instance = new SuggestedProducts(LocalStorage.getInstance(), Api.getInstance());
		}
		return SuggestedProducts.instance;
	}

	public getSuggestedProductKeys(max : number = 3,): Promise<string[]> {
		if(this.suggestedProductKeys == null) {
			return this.retrieveSuggestedProductKeys(max);
		}
		return Promise.resolve(this.suggestedProductKeys);
	}

	private async retrieveSuggestedProductKeys(max: number = 3): Promise<string[]> {
		const products = await this.api.getSuggestedProductKeys(max);
		this.suggestedProductKeys = products;
		this.saveSuggestedProductKeys();
		return products;
	}

	private getSuggestedProductsFromLocalStorage(): string[] {
		return this.localStorage.get("suggestedProducts.v2") || null;
	};

	private saveSuggestedProductKeys() {
		this.localStorage.set(
			"suggestedProducts.v2",
			this.suggestedProductKeys,
			Date.now() + SUGGESTED_PRODUCTS_CACHE_EXPIRATION_DURATION
		);
	}
}